// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__1PWS-","title":"style_title__3qDUl"};